/**
 * Redux Persist용 사용자별 Storage 구현
 */
import { getUserStorageKey, getCurrentUserId } from './userStorage';

const createUserStorage = () => {
  return {
    getItem: async (key) => {
      try {
        // Redux persist 키를 사용자별 키로 변환
        const userId = getCurrentUserId();
        let userKey;
        
        // Redux persist는 "persist:reducerName" 형태의 키를 사용
        if (key.startsWith('persist:')) {
          const reducerName = key.replace('persist:', '');
          userKey = getUserStorageKey(`persist_${reducerName}`, userId);
        } else {
          userKey = getUserStorageKey(key, userId);
        }
        
        const result = localStorage.getItem(userKey);
        console.log(`Redux persist getItem: ${key} → ${userKey} (user: ${userId})`);
        return result;
      } catch (error) {
        console.warn('Failed to get item from user storage:', error);
        return null;
      }
    },
    
    setItem: async (key, value) => {
      try {
        // Redux persist 키를 사용자별 키로 변환
        const userId = getCurrentUserId();
        let userKey;
        
        // Redux persist는 "persist:reducerName" 형태의 키를 사용
        if (key.startsWith('persist:')) {
          const reducerName = key.replace('persist:', '');
          userKey = getUserStorageKey(`persist_${reducerName}`, userId);
        } else {
          userKey = getUserStorageKey(key, userId);
        }
        
        localStorage.setItem(userKey, value);
        console.log(`Redux persist setItem: ${key} → ${userKey} (user: ${userId})`);
        return Promise.resolve();
      } catch (error) {
        console.warn('Failed to set item in user storage:', error);
        return Promise.reject(error);
      }
    },
    
    removeItem: async (key) => {
      try {
        // Redux persist 키를 사용자별 키로 변환
        const userId = getCurrentUserId();
        let userKey;
        
        // Redux persist는 "persist:reducerName" 형태의 키를 사용
        if (key.startsWith('persist:')) {
          const reducerName = key.replace('persist:', '');
          userKey = getUserStorageKey(`persist_${reducerName}`, userId);
        } else {
          userKey = getUserStorageKey(key, userId);
        }
        
        localStorage.removeItem(userKey);
        console.log(`Redux persist removeItem: ${key} → ${userKey} (user: ${userId})`);
        return Promise.resolve();
      } catch (error) {
        console.warn('Failed to remove item from user storage:', error);
        return Promise.reject(error);
      }
    },
    
    // Redux persist에서 사용하는 메서드들
    getAllKeys: async () => {
      try {
        const userId = getCurrentUserId();
        const userPrefix = `user_${userId}_persist_`;
        const keys = [];
        
        for (let i = 0; i < localStorage.length; i++) {
          const key = localStorage.key(i);
          if (key && key.startsWith(userPrefix)) {
            // 사용자별 키를 원래 형태로 복원
            const originalKey = key.replace(userPrefix, 'persist:');
            keys.push(originalKey);
          }
        }
        
        console.log(`Redux persist getAllKeys for user ${userId}:`, keys);
        return keys;
      } catch (error) {
        console.warn('Failed to get all keys from user storage:', error);
        return [];
      }
    }
  };
};

export default createUserStorage();